Guid = require '../helpers/guid.coffee'

class BaseModel
  constructor: (attributes) ->
    attributes ?= @defaultAttributes()
    @guid = if @id then @id else Guid.generateGuid()

    if @constructor.ATTRIBUTES
      for attr_name, attr_options of @constructor.ATTRIBUTES
        @setAttribute attr_name, attributes[attr_name], attr_options

    @guid = if @id then @id else Guid.generateGuid()

    if @constructor.ASSOCIATIONS
      for association_name, model_getter of @constructor.ASSOCIATIONS
        @buildAssociation association_name, model_getter(), attributes[association_name]

    @afterInitialize() if @afterInitialize

  isPersisted: ->
    !!@id

  isNew: ->
    !@isPersisted()

  setAttribute: (name, value, options = {}) ->
    if value isnt undefined
      if options.type and options.type == Date and value
        @[name] = moment value

      else
        @[name] = value

    else if options.default isnt undefined
      @[name] = options.default

    else
      @[name] = options.type and (new options.type) or null

  buildAssociation: (name, Model, attributes) ->
    if jQuery.isPlainObject(attributes)
      @[name] = new Model attributes

    else if jQuery.isArray(attributes)
      @[name] = []

      for _attributes in attributes
        model = new Model _attributes
        @[name].push(model)

    else
      @[name] = []

  defaultAttributes: ->
    attributes = {}

    for attribute_name in @constructor.ATTRIBUTES
      attributes[attribute_name] = null

    attributes

  serializableAttributes: ->
    if @constructor.SERIALIZABLE_ATTRIBUTES
      serializable = {}
      for attr_name in @constructor.SERIALIZABLE_ATTRIBUTES
        serializable[attr_name] = @constructor.ATTRIBUTES[attr_name]
      return serializable

    if @constructor.ATTRIBUTES
      return @constructor.ATTRIBUTES

    return []

  serializableAssociations: ->
    if @constructor.SERIALIZABLE_ASSOCIATIONS
      return @constructor.SERIALIZABLE_ASSOCIATIONS

    if @constructor.ASSOCIATIONS
      return Object.keys @constructor.ASSOCIATIONS

    return []

  isMoment: (obj) ->
    obj and typeof(obj) == 'object' and obj.constructor.name == 'Moment'

  serialize: (selected_attributes = false) ->
    serialized = {}

    for attr_name, attr_options of @serializableAttributes()
      if @isMoment @[attr_name]
        if @[attr_name].isValid()
          value = @[attr_name].utc().format()
        else
          value = null
      else
        value = @[attr_name]

      serialized[attr_name] = value

    delete serialized['id'] unless @isPersisted()

    for association_name in @serializableAssociations()
      continue unless @[association_name]
      serialized_name = "#{association_name}_attributes"

      if @[association_name].serialize
        serialized[serialized_name] = @[association_name].serialize()

      else
        serialized[serialized_name] = (instance.serialize() for instance in @[association_name])

    return serialized unless selected_attributes

    selected_serialized = {}

    for key in selected_attributes
      selected_serialized[key] = serialized[key]

    return selected_serialized

module.exports = BaseModel



// WEBPACK FOOTER //
// ./src/models/base_model.coffee